import API from "api/client";
import { envConfig } from "config";

const { emailAPI } = envConfig;

/**
 *
 * @param req {object}
 * @param req.address {string}
 * @returns {Promise<{}>}
 */
const createBlacklistEmail = (req) => {
  return API.post(`${emailAPI}blacklist`, req).then((res) => res.data);
};

export default {
  createBlacklist: createBlacklistEmail,
};
